import React from 'react';

interface RedirectProps {
    url: string;
}

export const Redirect = (props: RedirectProps) => {
    window.location.href = props.url;

    return <></>;
};
